import { yupResolver } from '@hookform/resolvers/yup'
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Grid from '@mui/material/Grid'
import { Button, Card, CardHeader, SelectC, TextFieldC } from 'components'
import { SelectCompany } from 'components/SelectCompany'
import { USER_ROLES_OPTION } from 'config/userRoles'
import { forwardRef, useImperativeHandle } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { Yup } from 'utils'
import { useLoadUsersSales } from '../hooks'
import { SelectUnities } from './SelectUnities'
import { SelectResponsible } from './SelectResponsible'

const userSchema = Yup.object({
  company: Yup.object({
    id: Yup.string()
  }).required(),
  username: Yup.string().max(20).required(),
  email: Yup.string().email().required(),
  function: Yup.object({
    id: Yup.string(),
    name: Yup.string()
  }).required(),
  // freights: Yup.array()
  //   .of(
  //     Yup.object({
  //       id: Yup.string().required(),
  //       name: Yup.string().required()
  //     }).required()
  //   )
  //   .required(),
  // priceTables: Yup.array()
  //   .of(
  //     Yup.object({
  //       id: Yup.string().required(),
  //       name: Yup.string().required()
  //     }).required()
  //   )
  //   .required(),
  salesTypes: Yup.array()
    .of(
      Yup.object({
        id: Yup.string().required(),
        name: Yup.string().required()
      }).required()
    )
    .required(),
  unities: Yup.array()
    .of(
      Yup.object({
        id: Yup.string().required(),
        name: Yup.string().required()
      })
    )
    .nullable(),
  responsibles: Yup.array()
    .of(
      Yup.object({
        id: Yup.string().required(),
        name: Yup.string().required()
      })
    )
    .nullable(),
  password: Yup.string(),
  active: Yup.object({
    id: Yup.string(),
    name: Yup.string()
  }).required()
})

const defaultValues = {
  company: null,
  productLine: null,
  username: '',
  email: '',
  function: null,
  freights: [],
  priceTables: [],
  salesTypes: [],
  unities: [],
  responsibles: [],
  password: '',
  active: null
}

export const UserForm = forwardRef(function UseForm(props: any, ref: any) {
  const navigation = useNavigate()
  const { onSubmit } = props

  const { data: sales, isLoading: salesLoading } = useLoadUsersSales({})

  const methods = useForm<any>({
    resolver: yupResolver(userSchema),
    reValidateMode: 'onChange',
    defaultValues: defaultValues
  })

  const { setValue } = methods

  useImperativeHandle(
    ref,
    () => ({
      setFormValues: (values: any) => {
        setValue('company', {
          id: values.user.customer.id,
          name: values.user.customer.name
        })
        setValue('username', values.user.username)
        setValue('password', '')
        setValue('email', values.user.email)
        setValue('function', {
          id: values.user.role.id,
          name: values.user.role.name
        })
        // setValue(
        //   'freights',
        //   values.freights.map((freight: any) => ({
        //     id: freight?.id,
        //     name: freight?.name
        //   }))
        // )
        // setValue(
        //   'priceTables',
        //   values.pricesTable.map((priceTable: any) => ({
        //     id: priceTable?.id,
        //     name: priceTable?.name
        //   }))
        // )
        setValue('salesTypes', values.salesType)
        setValue('unities', values.unities)
        setValue('responsibles', values.responsibles)
        setValue('active', {
          id: values.user.active === 1 ? '1' : '0',
          name: values.user.active === 1 ? 'SIM' : 'NÃO'
        })
      }
    }),
    [setValue]
  )

  const { handleSubmit } = methods

  return (
    <FormProvider {...methods}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Card
            sx={{
              visibility: { xs: 'hidden', sm: 'visible', md: 'visible' },
              padding: { xs: 0, sm: 0, md: 0 }
            }}
          >
            <Box
              sx={{
                visibility: { xs: 'visible', sm: 'visible', md: 'visible' }
              }}
            >
              <Box
                sx={{
                  padding: {
                    xs: 0,
                    sm: '22px 24px 0 24px',
                    md: '0px 24px 0 0px'
                  },
                  borderBottom: { xs: 'none', md: '1px solid #E0E0E0' },
                  marginBottom: { xs: 2, md: 0 }
                }}
              >
                <CardHeader title="Informações Básicas" />
              </Box>
              <Divider
                sx={{
                  visibility: { xs: 'hidden', sm: 'visible', md: 'visible' }
                }}
              />
              <Grid
                container
                spacing={3}
                sx={{
                  padding: { xs: 0, sm: '24px', md: '24px' },
                  marginBottom: { xs: 3, md: 0 }
                }}
              >
                <Grid item xs={12}>
                  <TextFieldC name="username" label="Nome de Usuário" />
                </Grid>
                <Grid item xs={12}>
                  <TextFieldC name="password" label="Senha" type="password" />
                </Grid>
                <Grid item xs={12}>
                  <TextFieldC name="email" label="E-mail" />
                </Grid>

                <Grid item xs={12}>
                  <SelectC
                    name="function"
                    label="Função"
                    getOptionLabel={(option: any) => option?.name}
                    options={USER_ROLES_OPTION}
                  />
                </Grid>

                <Grid item xs={12}>
                  <SelectC
                    name="active"
                    label="Ativo"
                    getOptionLabel={(option: any) => option?.name}
                    options={[
                      {
                        id: '0',
                        name: 'NÃO'
                      },
                      {
                        id: '1',
                        name: 'SIM'
                      }
                    ]}
                  />
                </Grid>
              </Grid>
            </Box>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Card
            sx={{
              visibility: { xs: 'hidden', sm: 'visible', md: 'visible' },
              padding: { xs: 0, sm: 0, md: 0 },
              marginBottom: { xs: 0, sm: 2, md: 2 }
            }}
          >
            <Box
              sx={{
                visibility: { xs: 'visible', sm: 'visible', md: 'visible' }
              }}
            >
              <Box
                sx={{
                  padding: {
                    xs: 0,
                    sm: '22px 24px 0 24px',
                    md: '0px 24px 0 0px'
                  },
                  borderBottom: { xs: 'none', md: '1px solid #E0E0E0' },
                  marginBottom: { xs: 2, md: 0 }
                }}
              >
                <CardHeader title="Vínculos" />
              </Box>
              <Divider
                sx={{
                  visibility: { xs: 'hidden', sm: 'visible', md: 'visible' }
                }}
              />
              <Grid
                container
                spacing={3}
                sx={{
                  padding: { xs: 0, sm: '24px', md: '24px' },
                  marginBottom: { xs: 3, md: 0 }
                }}
              >
                <Grid item xs={12}>
                  <SelectCompany />
                </Grid>

                {/* <Grid item xs={12}>
                  <SelectC
                    name="freights"
                    label="Tipos de Fretes"
                    getOptionLabel={(option: any) => option?.name}
                    options={freightType?.data || []}
                    loading={freightTypeLoading}
                    isMultiple={true}
                    disableCloseOnSelect
                  />
                </Grid>
                <Grid item xs={12}>
                  <SelectC
                    name="priceTables"
                    label="Tabelas de Preço"
                    getOptionLabel={(option: any) => option?.name}
                    options={priceTables?.data || []}
                    loading={priceTablesLoading}
                    isMultiple={true}
                    disableCloseOnSelect
                  />
                </Grid> */}
                <Grid item xs={12}>
                  <SelectC
                    name="salesTypes"
                    label="Tipos de Venda"
                    getOptionLabel={(option: any) => option?.name}
                    options={sales?.data || []}
                    loading={salesLoading}
                    isMultiple={true}
                    disableCloseOnSelect
                  />
                </Grid>
                <Grid item xs={12}>
                  <SelectUnities />
                </Grid>
                <Grid item xs={12}>
                  <SelectResponsible />
                </Grid>
              </Grid>
            </Box>
          </Card>
        </Grid>
      </Grid>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          gap: '1rem'
        }}
      >
        <Button
          variant="text"
          onClick={() => navigation('/users')}
          sx={{ width: 180 }}
        >
          Cancelar
        </Button>
        <Button
          variant="contained"
          sx={{ width: 180 }}
          onClick={handleSubmit(onSubmit)}
        >
          Cadastrar
        </Button>
      </Box>
    </FormProvider>
  )
})
